import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';


@Injectable({providedIn: 'root'})
export class HelpCenterGuard  {

    constructor() { }

    canActivate() {
        return environment.design.showHelpCenterLink;
    }
}